<script lang="ts">
    import { _ } from "svelte-i18n"
    import { kirbyFetch } from "../../../../api/kirby/api"
    import { getPageSelect } from "../../../../api/kirby/queries"
    import { spaLink } from "../../../../functionTools/routing"
    import { lang } from "../../../../store"
    import AnimatingMoreArrow from "../../../widgets/AnimatingMoreArrow.svelte"
    import MedialibImage from "../../../widgets/MedialibImage.svelte"
    import { animateOnVisible } from "../../../../configs/config"
    let { block }: { block: PersonCardsBlock } = $props()
    const cnt = block.content
    const persons: PersonpageContent[] = $state([])
    let active = $state(-1)
    Promise.all(
        cnt.persons.map((person) =>
            kirbyFetch<PersonpageContent>({
                query: `page("${person}")`,
                select: getPageSelect(),
            })
        )
    ).then((results) => {
        persons.push(...results)
        const commonProps = {
            duration: 300,
            opacity: [0, 1],
            easing: "cubicBezier",
        }
        animateOnVisible(".preview-list .content h3", {
            translateY: ["30px", "0rem"],
            scale: [0.7, 1],
            delay: 300,
            ...commonProps,
        })

        animateOnVisible(".preview-list .content .to-profile, .preview-list .content .department", {
            delay: 1000,
            ...commonProps,
        })
    })
</script>

<ul class="preview-list">
    {#each persons as person, idx}
        <li>
            <a href="/{$lang}/{person?.url?.split(`/${$lang}/`)?.pop()}" use:spaLink>
                <div class="bg-image">
                    <MedialibImage id={person.preview_img} alt="person preview" maxWidth={420} />
                </div>
                <div class="content">
                    <span class="department">{person.department}</span>
                    <div class="lower-content">
                        <h3>
                            {person.person_academic_titles.replaceAll(",", "")}
                            {person.person_name}
                        </h3>
                        <!-- svelte-ignore a11y_no_static_element_interactions -->
                        <div
                            onmouseenter={() => (active = idx)}
                            onmouseleave={() => (active = -1)}
                            class="to-profile"
                            class:active={active == idx}
                        >
                            <span>{$_("general.to-profile")}</span>
                            <AnimatingMoreArrow active={active == idx} color={"white"} />
                        </div>
                    </div>
                </div>
            </a>
        </li>
    {/each}
</ul>

<style lang="less" global>
    @import "../../../../css/variables.less";
    ul.preview-list {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(408px, 1fr));
        gap: 1.2rem 2.4rem;

        width: 100%;
        padding-top: 1.2rem;
        li {
            width: 100%;
            height: 568px;
            position: relative;
            a {
                height: 100%;
                width: 100%;
                .bg-image {
                    position: absolute;
                    top: 0px;
                    left: 0px;
                    width: 100%;
                    height: 100%;
                    z-index: 0;
                    &::before {
                        position: absolute;
                        content: "";
                        z-index: 2;
                        top: 0px;
                        left: 0px;
                        width: 100%;
                        height: 100%;
                        background: radial-gradient(circle at 50% 50%, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.2) 100%);
                    }
                    img {
                        height: 100%;
                        width: 100%;
                        object-fit: cover;
                        position: relative;
                        border-radius: 4px;
                    }
                }
                .content {
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    align-items: flex-start;
                    position: relative;
                    z-index: 2;
                    padding: 1.2rem;
                    height: 100%;
                    & > span {
                        font-size: 14px;
                        font-weight: 700;
                        text-transform: uppercase;
                        color: var(--bright-100);
                    }
                    .lower-content {
                        display: flex;
                        flex-direction: column;
                        gap: 0.6rem;
                        width: 100%;
                        h3 {
                            color: var(--bright-100);
                        }
                        .to-profile {
                            width: 100%;
                            display: flex;
                            justify-content: space-between;
                            span {
                                color: var(--bright-100);
                                font-size: 14px;
                                font-weight: 400;
                                text-transform: uppercase;
                                transition: color 0.3s;
                            }
                            &.active {
                                span {
                                    color: var(--brand-100);
                                }
                            }
                        }
                    }
                }
            }
        }
        @media @max-mobile {
            display: flex;
            flex-direction: column;
            gap: 1.2rem;
        }
    }
</style>
